module.exports = __webpack_public_path__ + "img/icon-support-phone-white.b65e4f62.svg";